'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { fetchData } from '@eliadmin/core/src/api/fetcher';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import type { Reference } from '@eliadmin/core/src/api/references/references-types';
import PropertyCard from '@eliadmin/core/src/components/shared/property-card';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const RealizationList = () => {
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);
  const referencesQuery = useSuspenseInfiniteQuery({
    queryKey: ['references'],
    queryFn: async ({ pageParam = 1 }) => {
      return await fetchData({
        method: 'GET',
        uri: `/store/references`,
        query: {
          page: pageParam,
          results: 6,
        },
        locale,
      });
    },
    getNextPageParam: (lastPage: any, pages) => {
      if (lastPage?.meta?.current_page < lastPage?.meta?.last_page)
        return lastPage?.meta?.current_page + 1;
      return undefined;
    },
    initialPageParam: 1,
  });

  const references = referencesQuery.data?.pages.flatMap((page: any) => page.data) ?? [];

  return (
    <>
      <div className={cn('', 'ea-realization-list__content-wrapper')}>
        {references?.map((reference: Reference) => (
          <PropertyCard key={reference.name} realization={reference} />
        ))}
      </div>

      <div
        className={cn('', 'ea-realization-list__show-more-div', {
          'hide-show-more': !referencesQuery.hasNextPage,
        })}
      >
        <Button
          onClick={() => referencesQuery.fetchNextPage()}
          isLoading={referencesQuery.isFetchingNextPage}
          variant={'outline'}
          className="text-white"
        >
          {t('text338')}
        </Button>
      </div>
    </>
  );
};
